const Global = {
  API_URL: process.env.REACT_APP_API_URL,
  PROP: process.env.REACT_APP_PROP,
}

Global.PROP = Global.PROP ? Global.PROP.toString() : '';
console.log(Global);
export default { ...Global };